// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__22zl9","head":"Table_head__1XGii","col":"Table_col__3Pfji"};